"use client";

import React from "react";
import CarouselSection from "../ui/carousel-section";
import CategoryCard from "./category-card";
import { CategoryModel } from "@/types/category";

const CategoriesCarousel = ({
  chunkedCategories,
}: {
  chunkedCategories: any[];
}) => {
  const renderCategoryCard = (cat: CategoryModel) => (
    <CategoryCard key={cat.id} cat={cat} />
  );

  return (
    <CarouselSection
      items={chunkedCategories}
      breakpoints={{
        base: "basis-[50%]",
      }}
      renderItem={(group) => (
        <div className="grid grid-cols-1 gap-4">
          {group.map((cat: CategoryModel) => renderCategoryCard(cat))}
        </div>
      )}
    />
  );
};

export default CategoriesCarousel;
